import React, { PropTypes } from "react";
import ComponentRegistry from "Fratello/Common/ComponentRegistry";

export default function Summary({ title, value, requiresVat, labels }) {
    const Price = ComponentRegistry.get("Price");

    return (
      <div className="row">
          <div className="col-xs-12 col-sm-6 col-sm-offset-6 box-total">
              <div className="row">
                  <div className="col-xs-6 column text-right">
                      <span className="price-lg">{title}</span>
                  </div>
                  <div className="col-xs-6 column text-right">
                      <span className="column price-lg">{value}</span>
                  </div>
              </div>
          </div>
      </div>
    );
}
Summary.propTypes = {
    title: PropTypes.string,
    value: PropTypes.string,
    requiresVat: PropTypes.bool,
    labels: PropTypes.shape({
        vat_incl: PropTypes.string.isRequired,
        vat_excl: PropTypes.string.isRequired,
    })
};



// WEBPACK FOOTER //
// ./app/Resources/public/rosco/js/Basket/Atoms/Summary.jsx